import React from 'react'
import LoadingContent from '../Loaders/LoadingContent'
import { ErrorBoundary } from 'features/common/ui/ErrorBoundary'

interface Props {
  children: React.ReactNode
  FallBack?: React.ReactNode
}

function LazyLoad({ children, FallBack }: Props) {
  return (
    <ErrorBoundary>
      <React.Suspense fallback={FallBack || <LoadingContent />}>{children}</React.Suspense>
    </ErrorBoundary>
  )
}

export default LazyLoad
